<script>
import VueQr from 'vue-qr'
import VueBarcode from 'vue-barcode'

export default {
  name: 'User',
  components: { VueQr, VueBarcode },
  props: {
    userInfo: null
  },
  data() {
    return {
      show: false,
      codeFlag: false,
      menus: [
        {
          img: require('../../assets/images/user/zxkf.png'),
          name: '在线客服',
          url: 'https://work.weixin.qq.com/kfid/kfc5a24b7e7901cd8da'
        },
        {
          img: require('../../assets/images/user/dhkf.png'),
          name: '电话客服',
          url: ''
        },
        {
          img: require('../../assets/images/user/yjfk.png'),
          name: '意见反馈',
          url: '/feedback'
        },
        {
          img: require('../../assets/images/user/cjwt.png'),
          name: '常见问题',
          url: '/dynamic'
        },
        {
          img: require('../../assets/images/user/ghms.png'),
          name: '关怀模式',
          url: '/moduleSetting'
        },
        {
          img: require('../../assets/images/user/dzfp.png'),
          name: '电子发票',
          url: '/myPatient?url=eInvoice'
        }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.name === '电话客服') {
        window.location.href = `tel:${this.$store.state.hospitalInfo.hospitalPhone}`
      } else if (item.name === '在线客服') {
        window.location.href = item.url
      } else if (item.name === '常见问题') {
        this.$router.push({ path: item.url })
      } else if (item.url) {
        if (this.userInfo && this.userInfo.id) {
          this.$router.push({ path: item.url })
        } else {
          this.$dialog.confirm({
            title: '提示',
            message: '请先添加就诊人'
          }).then(() => {
            this.$router.push(`/addPatient?id=${this.$store.state.openId}&isNotSelf=1`)
          }).catch(() => {
            return false
          })
        }
      }
    },
    addPatient() {
      this.$router.push(`/addPatient?id=${this.$store.state.openId}&isNotSelf=1`)
    },
    showQrcode() {
      this.show = true
    },
    checkDetail(id) {
      this.$router.push(`/patientInfo?id=${id}`)
    },
    hideName(name) {
      if (!name) return ''
      return '*'.repeat(1) + name.slice(1)
    }
  }
}
</script>

<template>
  <div class="page-container">
    <div class="page-top">
      <div class="l1">您好!</div>
      <div v-if="userInfo&&userInfo.id" class="l3" @click="checkDetail(userInfo.id)">
        <span>{{ hideName((userInfo&&userInfo.patientName)?userInfo.patientName:'') }} </span>
        <van-icon name="arrow" />
      </div>
      <div v-else class="l2" @click="addPatient">
        <span>您还没有维护本人就诊人信息，请先维护 </span>
        <van-icon name="arrow" />
      </div>
      <div v-if="userInfo&&userInfo.id" class="icon2" @click="showQrcode" />
      <div v-else class="icon1" />
    </div>
    <div class="menu-bg">
      <div class="menu-list">
        <div v-for="item in menus" :key="item.name" class="menu-item" @click="handleClick(item)">
          <img :src="item.img">
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>

    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="code-dialog">
          <div class="close" @click="show=false">
            <van-icon name="cross" size="21" />
          </div>
          <p class="user-name">{{ (userInfo&&userInfo.patientName)?userInfo.patientName:'' }}</p>
          <div class="code-area">
            <div class="qr-code">
              <vue-qr :text="(userInfo&&userInfo.blhNo)?userInfo.blhNo:''" :size="300" :correct-level="3" />
            </div>
            <div class="bar-code">
              <vue-barcode :value="(userInfo&&userInfo.blhNo)?userInfo.blhNo:''" format="CODE128" height="60" :width="3" />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<style scoped lang="less">
.page-container {
  padding: 13px;
}

.page-top {
  border-radius: 12px;
  background: url("../../assets/images/user/top_bg.png") no-repeat center center;
  background-size: cover;
  height: 21vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 25px;
  position: relative;
  margin-bottom: 13px;

  .l1 {
    color: #d3e5ff;
    font-size: 15px;
    font-weight: bold;
    line-height: 2;
    letter-spacing: 0.5px;
  }

  .l2 {
    color: #fff;
    font-size: 13px;
    line-height: 2;
  }

  .l3 {
    color: #fff;
    font-size: 14px;
    line-height: 2;
    letter-spacing: 0.5px;
  }

  .icon1 {
    position: absolute;
    background: url("../../assets/images/user/user.png") no-repeat center center;
    background-size: 50%;
    height: 21vw;
    width: 21vw;
    right: 0;
    top: 0;
  }

  .icon2 {
    position: absolute;
    background: url("../../assets/images/user/qr_code.png") no-repeat center center;
    background-size: 50%;
    height: 21vw;
    width: 21vw;
    right: 0;
    top: 0;
  }
}

.menu-bg {
  border-radius: 12px;
  height: calc(100vh - 55vw);
  background: url("../../assets/images/user/menu_bg.png") no-repeat center center;
  background-size: 100% 100%;
}

.menu-list {
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  justify-content: flex-start;

  .menu-item:active {
    opacity: 0.7;
  }

  .menu-item {
    display: flex;
    flex-direction: column;
    width: 25%;
    margin-bottom: 15px;

    img {
      width: 58%;
      height: auto;
      margin: 0 auto;
    }

    p {
      text-align: center;
      font-size: 14px;
      color: #333;
      font-weight: bold;
      line-height: 2.5;
      letter-spacing: 0.5px;
    }
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.code-dialog {
  position: relative;
  width: 80vw;
  height: 120vw;
  margin-bottom: 20vw;
  border: 1px solid #d3e8ff;
  border-radius: 20px;
  background-color: #fff;
  background: linear-gradient(190deg, rgba(23, 139, 246, 1) 0%, rgba(83, 171, 249, 1) 65%, rgba(168, 218, 254, 1) 100%);

  .close {
    position: absolute;
    right: 13px;
    top: 15px;
    color: #fff;
  }

  .user-name {
    font-size: 21px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    letter-spacing: 1px;
    line-height: 22vw;
  }

  .code-area {
    border-radius: 10px;
    background: #fff;
    height: 90vw;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .qr-code {
    margin-top: 7vw;
    height: 50vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #d3e8ff;
    border-radius: 8px;
    width: 75%;

    img {
      width: 86%;
      height: auto;
    }
  }

  .bar-code {
    height: 35vw;
    width: 86%;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep svg {
      width: 100% !important;
    }
  }
}

</style>
